import { Box, FlexBox } from '@dixa/lib-shared-habla';
import cx from 'classnames';

import placeholderStyles from './placeholders.module.scss';

export function CollectionEditPagePlaceholder(): JSX.Element {
  const items = Array.from(Array(20));

  return (
    <>
      {items.map((_, i) => {
        return (
          <FlexBox
            height="64px"
            padding="16px 24px"
            justifyContent="space-between"
            key={i}
            alignItems="center"
            className={placeholderStyles.categoryRow}
          >
            <FlexBox gap="16px">
              <Box
                height="16px"
                width="16px"
                className={placeholderStyles.placeholder}
              />
              <Box
                height="16px"
                width="16px"
                className={placeholderStyles.placeholder}
              />
              <Box
                height="16px"
                width="240px"
                className={placeholderStyles.placeholder}
              />
            </FlexBox>
            <FlexBox>
              <Box
                height="16px"
                width="16px"
                className={placeholderStyles.placeholder}
              />
            </FlexBox>
          </FlexBox>
        );
      })}
    </>
  );
}

export function TopBarPlaceholder(): JSX.Element {
  const placeholder = placeholderStyles.placeholder;
  const placeholderRound = cx(
    placeholderStyles.placeholder,
    placeholderStyles.placeholderRound,
  );

  return (
    <Box className={placeholderStyles.head}>
      <FlexBox flexDirection="column" gap="4px">
        <Box height="20px" width="160px" className={placeholder} />
        <Box height="12px" width="80px" className={placeholder} />
      </FlexBox>
      <FlexBox
        className={placeholderStyles.slotRight}
        gap="8px"
        alignItems={'center'}
      >
        <Box height="32px" width="32px" className={placeholderRound} />
        <Box height="32px" width="32px" className={placeholderRound} />
        <Box height="32px" width="105px" className={placeholderRound} />
        <Box height="32px" width="90px" className={placeholderRound} />
      </FlexBox>
    </Box>
  );
}
